import { z } from "zod";
import { exerciseMuscleActivation } from "./exercise-detail";
import { exerciseListItem } from "./exercise-list";
import { catalogueLocale } from "./vocabulary";
/**
 * `GET /catalog/snapshot` — the whole catalogue, once, for the device
 * (`D194`).
 *
 * ── WHY THE DEVICE HOLDS IT ────────────────────────────────────────────────
 * Offline, the catalogue was a page at a time from the server and nothing
 * else: the exercise sheet of anything not opened before, search, and the
 * picker's catalogue all answered "could not load". The catalogue is the
 * same for everyone and changes only when it is re-ingested, so one copy per
 * locale is kept on the device and read when the network is not there — a
 * card list (`exerciseListItem`) with each exercise's muscles, which is what
 * a card, a sheet's header and a muscle filter need.
 *
 * ── WHY IT DOES NOT COST WHAT `T-6` PRICES ─────────────────────────────────
 * Built from paged reads and one batched muscle read, never a scan per
 * request: the Worker builds it at most once per isolate and locale, keeps it
 * in the edge cache for a day, and answers `If-None-Match` with 304. A device
 * asks at most once a day.
 *
 * Instructions are NOT carried: they are most of a detail's bytes, and the
 * sheet reads them from `GET /catalog/exercises/:id` online, as before.
 */
export const catalogueSnapshotQuery = z.object({
    locale: catalogueLocale.optional(),
});
export const catalogueSnapshotItem = exerciseListItem.extend({
    /** Targets first, then hardest-worked — the detail's own order. */
    muscles: z.array(exerciseMuscleActivation),
});
export const catalogueSnapshotOutput = z.object({
    /** Most popular first, as the list orders them. */
    items: z.array(catalogueSnapshotItem),
    /** A digest of `items`: the same catalogue, the same version (the ETag). */
    version: z.string().min(1),
});
//# sourceMappingURL=snapshot.js.map